import { Immobile } from "./immobile";
import { Trascodifica } from "./trascodifica";

export class BloccoImmobile{
    id: number;
    dataCreazione: Date;
    dataInizio: Date;
    dataFine: Date;
    idImmobile: number;
    idStato: number;
    immobile: Immobile;
    stato: Trascodifica;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/blocco-immobile.ts